module.exports = __webpack_public_path__ + "static/media/EE102.15322847.PNG";